import React from 'react';

interface ChooseLoginMethodProps {
  error: string;
  onChooseBiometrics: () => void;
  onChoosePassword: () => void;
}

const ChooseLoginMethod = ({
  error,
  onChooseBiometrics,
  onChoosePassword,
}: ChooseLoginMethodProps) => {
  return (
    <div className="panel user-auth-card pb-5">
      <div className="panel-header">
        <h2>How would you like to log in?</h2>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
      <div className="panel-body">
        <div className="d-flex flex-column">
          <button className="btn btn-primary mb-3" onClick={onChooseBiometrics}>
            Use Biometric Login
          </button>
          <button className="btn" onClick={onChoosePassword}>
            Use Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseLoginMethod;
